"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overwriteFilter = overwriteFilter;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//  Scan filtersObj and look for fields that match filterMapping, apply the value of the filterMapping to the filter.
//  Example filterMapping:
//  { i_device_type: { filterField: 'i_device_subtype', filterValue: 'router' }}

function overwriteFilter(filtersObj, filterMapping, valueMatch) {
  if (filtersObj) {
    var _filtersObj$filterGro;
    if (filtersObj.filters) {
      filtersObj.filters = filtersObj.filters.map(function (filter) {
        var overrides = filterMapping[filter.filterField] || {};
        // override only if filterValue matches valueMatch
        if (valueMatch && filter.filterValue !== valueMatch) {
          return _objectSpread({}, filter);
        }
        return _objectSpread(_objectSpread({}, filter), overrides);
      });
    }
    if (filtersObj.filterGroups && !((_filtersObj$filterGro = filtersObj.filterGroups) !== null && _filtersObj$filterGro !== void 0 && _filtersObj$filterGro.some(function (group) {
      var _group$name;
      return (_group$name = group.name) === null || _group$name === void 0 ? void 0 : _group$name.startsWith('mkp_preview');
    }))) {
      filtersObj.filterGroups.forEach(function (filterGroup) {
        return overwriteFilter(filterGroup, filterMapping, valueMatch);
      });
    }
  }
}